module.exports = __webpack_public_path__ + "img/business1.7815f5ad.png";